// Tiny pub-sub so a help affordance anywhere in the tree can ask the ONE
// global Resources panel (mounted once in AppShell) to open on a specific
// topic, or ask the ONE mounted guided tour on the current page to start —
// without prop-drilling or a global state library for what is a single,
// app-wide fire-and-forget request.

type TopicListener = (topic: string) => void
type TourListener = (tourId: string) => void

const topicListeners = new Set<TopicListener>()
const tourListeners = new Set<TourListener>()

/** Ask the mounted Resources panel to open, scrolled to `topic`. */
export function requestResourcesPanel(topic: string): void {
  topicListeners.forEach((l) => l(topic))
}

export function onResourcesPanelRequest(listener: TopicListener): () => void {
  topicListeners.add(listener)
  return () => topicListeners.delete(listener)
}

/** Ask whichever page owns `tourId` to (re)start its guided tour. */
export function requestTour(tourId: string): void {
  tourListeners.forEach((l) => l(tourId))
}

export function onTourRequest(listener: TourListener): () => void {
  tourListeners.add(listener)
  return () => tourListeners.delete(listener)
}
